// Ring Modal
document.getElementById('openRingModal').addEventListener('click', function(event) {
  event.preventDefault();
  document.getElementById('ringModal').style.display = 'block';
});

document.getElementById('closeRingModal').addEventListener('click', function() {
  document.getElementById('ringModal').style.display = 'none';
});

// Bracelet Modal
document.getElementById('openBraceletModal').addEventListener('click', function(event) {
  event.preventDefault();
  document.getElementById('braceletModal').style.display = 'block';
});

document.getElementById("openModal").addEventListener("click", function(event) {
  event.preventDefault();  // Prevent default link behavior
  document.getElementById("modalOverlay").style.display = "block";  // Show overlay
  document.getElementById("sizeGuideModal").style.display = "block";  // Show modal
});

document.getElementById("closeModal").addEventListener("click", function() {
  document.getElementById("modalOverlay").style.display = "none";  // Hide overlay
  document.getElementById("sizeGuideModal").style.display = "none";  // Hide modal
});

document.getElementById("modalOverlay").addEventListener("click", function() {
  document.getElementById("modalOverlay").style.display = "none";  // Hide overlay
  document.getElementById("sizeGuideModal").style.display = "none";  // Hide modal
});
